import { useEffect, useState } from 'react'
import axios from 'axios'
import Query from '../../tools/query'
import { useNavigate } from 'react-router-dom'
import Spinner from '../../components/spinner'
import { Button, Typography } from '@iziplay/ui-kit'

export function MusicPrepare() {
  const navigate = useNavigate()
  const [loading, setIsLoading] = useState<boolean>(false)
  const [err, setErr] = useState<string | undefined>()

  const prepare = async () => {
    const params = Query.parse(location.search)
    if (!params.artist || !params.release) {
      setErr('artist and release cannot be found if not specified')
      return
    }

    setIsLoading(true)
    try {
      const res = await axios.request({
        method: 'POST',
        url: `${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/prepare`,
        data: {
          type: params.type ?? 'text',
          artist: decodeURIComponent(params.artist),
          release: decodeURIComponent(params.release)
        }
      })
      navigate(`/music/${res.data.artist.id}/${res.data.release.id}`)
    } catch (e: any) {
      setErr(typeof e.response?.data.message === 'string' ? e.response.data.message : 'Unknown error')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    prepare()
  }, [])

  if (err && !loading) {
    return (
      <div className="scrollable" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <img style={{ filter: 'grayscale(100%)', maxWidth: '20em' }} src="/img/logo.svg" alt="iziplay" />
        <Typography>It seems that we can&apos;t find this release for you.</Typography>
        <Typography variant="body2">Message: {err}</Typography>
        <div style={{ marginTop: '2em' }}>
          <Button variant="contained" onClick={() => prepare()}>Retry</Button>
        </div>
      </div>
    )
  }

  return (
    <div className="scrollable" style={{ display: 'flex', flexDirection: 'column' }}>
      <Spinner />
    </div>
  )
}
